import { incomeAndExpenseTypeService } from '@/modules/global-settings/loan-origination/services/other-settings/income-and-expenditure-type.service';
import { make } from 'vuex-pathify';
// Create a new instance of the incomeAndExpenseTypeService class
const service = new incomeAndExpenseTypeService();
// Define the state of the module
export const state = {
  incAndExpTypes: []
};
// Define the mutations of the module
export const mutations = {
  ...make.mutations(state)
};
// Define the actions of the module
export const actions = {
  /**
   * Fetches the income and expenditure types
   * @async
   * @param {object} commit - vuex commit
   * @returns {number} status - status of the request
   * @private This will set the state of the income and expenditure types
   */
  async getIncAndExpTypes({ commit }) {
    const result = await service.getIncAndExpTypes();
    if (result.status == 200) {
      commit('SET_INC_AND_EXP_TYPES', result.data);
    }
    return result.status;
  },

  /**
   * Creates a new income and expenditure type
   * @async
   * @param {object} dispatch - vuex dispatch
   * @param {object} incAndExpType - income and expenditure type
   * @returns {number} status - status of the request
   * @private This will dispatch the getIncAndExpTypes action
   */
  async createIncAndExpTypes({ dispatch }, incAndExpType) {
    const result = await service.createIncAndExpTypes(incAndExpType);
    if (result.status == 201) {
      dispatch('getIncAndExpTypes');
    }
    return result.status;
  },

  /**
   * Deletes an income and expenditure type
   * @async
   * @param {object} dispatch - vuex dispatch
   * @param {number} ID - id of the income and expenditure type
   * @returns {number} status - status of the request
   * @private This will dispatch the getIncAndExpTypes action
   */
  async updateIncAndExpType({ dispatch }, { id, updates }) {
    const result = await service.updateIncAndExpType(id, updates);
    if (result.status == 200) {
      dispatch('getIncAndExpTypes');
    }
    return result.status;
  }
};
// Define the getters of the module
export const getters = { ...make.getters(state) };
